import React from 'react';
//import { Link } from "react-router-dom";

import OwlCarouselSliderHomeTestimonial from '../../common/gallery/OwlCarouselSliderHomeTestimonial';
import DataGalleryTestimonial from '../../common/data/DataGalleryTestimonial';

var bg_six = require('../../assets/images/background/bg-6.jpg');

const TestimonialBlock = (props) => {	  	
    return(
	<>
	{/* <!-- OUR TESTIMONIAL SECTION START  --> */}
	<div className="section-full bg-gray bg-repeat p-t100 p-b70" style={{backgroundImage:`url(${bg_six})`}}>
		<div className="container">
			{/* <!-- TITLE START--> */}
			<div className="section-head text-center">
				<h1><span className="site-text-primary">What</span> Parents Say</h1>
				<div className="wt-separator-outer ">
					<div className="wt-separator style-icon">
						<i className="fa fa-leaf text-black"></i>
						<span className="separator-left site-bg-primary"></span>
						<span className="separator-right site-bg-primary"></span>
					</div>                            
				</div>
				<p>Parents generally express positive views about schools that provide a safe, nurturing, and stimulating learning environment. They appreciate schools that offer a well-rounded education, including practical teaching methods and opportunities for their children to develop confidence and express themselves.</p>
			</div>
			
			
			{/* <!-- TITLE END--> */}
			<div className="section-content">
				
				<OwlCarouselSliderHomeTestimonial data={DataGalleryTestimonial} radiusBx={props.radiusBx} radius={props.radius} />
			
				
			</div>
		</div>
	</div>
	{/* <!-- OUR TESTIMONIAL SECTION END  --> */}  
    </>
    )
}
export default TestimonialBlock;